import { apiClient, handleResponse } from './axios';

async function getQuestions() {
  try {
    const response = await apiClient.get('/question');
    const questions = await handleResponse(response);
    return questions;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

async function getQuestionPoolsWithQuestions() {
  try {
    const response = await apiClient.get('/qpool/questions');
    const pools = await handleResponse(response);
    return pools;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

async function getQuestionPoolWithQuestions(id) {
  try {
    const response = await apiClient.get(`/qpool/questions/${id}`);
    const pools = await handleResponse(response);
    return pools;
  } catch (error) {
    const res = await Promise.reject(error.response.data.message);
    return res;
  }
}

async function updateQuestion(id, body) {
  try {
    const response = await apiClient.put(`/question/${id}`, body);
    const semester = await handleResponse(response);
    return semester;
  } catch (error) {
    return error.response;
  }
}

const questionServices = {
  getQuestions,
  getQuestionPoolsWithQuestions,
  getQuestionPoolWithQuestions,
  updateQuestion,
};

export default questionServices;
